import { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ButtonLoading } from "go-form";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { FormSelectGroup } from "go-form/components/FormSelect";
import { adminApi } from "../../../../../../../services/Api/Admin/adminApi";
import { UserApi, UserRole } from "../../../../../../../services/Api/types";

interface Props {
	user: UserApi;
	onHide: (data?: UserApi) => void;
}

interface FormProps {
	roles: UserRole[];
}

const ChangeRoleModal = ({ user, onHide }: Props) => {
	const form = useForm<FormProps>({
		defaultValues: {
			roles: user.roles,
		},
	});
	const { addFlash, addSuccessFlash } = useFlash();
	const {
		formState: { errors },
		control,
		handleSubmit,
	} = form;
	const [loading, setLoading] = useState(false);
	const { t } = useTranslation("admin");
	const roleOptions = [
		{
			label: t("enums.roles.ADMIN"),
			value: UserRole.ADMIN,
		},
		{
			label: t("enums.roles.USER"),
			value: UserRole.USER,
		},
		{
			label: t("enums.roles.SUPPORT"),
			value: UserRole.SUPPORT,
		},
		{
			label: t("enums.roles.IT_SUPPORT"),
			value: UserRole.IT_SUPPORT,
		},
		{
			label: t("enums.roles.POSNET"),
			value: UserRole.POSNET,
		},
		{
			label: t("enums.roles.OFFICE"),
			value: UserRole.OFFICE,
		},
		{
			label: t("enums.roles.SALE"),
			value: UserRole.SALE,
		},
		{
			label: t("enums.roles.SALE_TL"),
			value: UserRole.SALE_TL,
		},
		{
			label: t("enums.roles.CS_TL"),
			value: UserRole.CS_TL,
		},
		{
			label: t("enums.roles.CSV_TL"),
			value: UserRole.CSV_TL,
		},
	];

	const onSubmit = handleSubmit(async (data: FormProps) => {
		setLoading(true);
		try {
			const res = await adminApi.updateAdminUserRoles(user.id, data.roles);
			addSuccessFlash(t("common.flash.saved", { ns: "lib" }));
			onHide(res);
		} catch (e) {
			handleError.alert(e, addFlash);
		}
		setLoading(false);
	});

	return (
		<Modal show onHide={onHide}>
			<Form>
				<Modal.Header>
					<h5>{t("modules.user.field.change_role.title")}</h5>
				</Modal.Header>
				<Modal.Body>
					<FormSelectGroup
						isMulti
						label={"Role"}
						name="roles"
						errors={errors}
						options={roleOptions}
						control={control}
						data-testid="roles"
					/>
				</Modal.Body>
			</Form>
			<Modal.Footer>
				<ButtonLoading loading={loading} type="submit" onClick={onSubmit}>
					{t("common.action.save", { ns: "lib" })}
				</ButtonLoading>
				<Button variant="light" onClick={() => onHide()}>
					{t("common.action.cancel", { ns: "lib" })}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};
export default ChangeRoleModal;
